import { render, staticRenderFns } from "./StudentListPage.vue?vue&type=template&id=4296813c&scoped=true"
import script from "./StudentListPage.vue?vue&type=script&lang=js"
export * from "./StudentListPage.vue?vue&type=script&lang=js"
import style0 from "./StudentListPage.vue?vue&type=style&index=0&id=4296813c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4296813c",
  null
  
)

export default component.exports